import React from "react";
import { Form, Input, Button, Select, Upload } from "antd";
import utils from "../../../../../../../../../utils/utils";
import { useTranslation } from "react-i18next";
import Validator from "../../../../../../../utils/formValidator";
import "../../../../../../../assets/personalCenter.scss";

const { Option } = Select;

const FeedbackModalRender = ({
  problemTypeList,
  email,
  form,
  submitting,
  handleSubmitFeedback,
  uploadProps,
  uploading,
  uploadFileObj,
  handleDeleteFile,
}) => {
  const { t } = useTranslation(["personalCenterSetting", "common"]);
  return (
    <div className="feedback-modal p-md-4 p-0">
      <h4 className="fw-bold mb-2">{t("feedbackTitle")}</h4>
      <p className="text-muted mb-4">{t("feedbackModalSubtitle")}</p>
      <Form
        layout="vertical"
        ref={form}
        name="feedback-form"
        className="w-100 mb-3"
        onFinish={handleSubmitFeedback}
        validateTrigger="onBlur"
        initialValues={{
          email: email,
          problem: problemTypeList[0].value,
        }}
      >
        <Form.Item
          name="problem"
          label={t("feedBackModalProductSelectQuestion")}
          rules={[
            {
              required: true,
              validator: Validator.emptyValidator,
            },
          ]}
        >
          <Select
            placeholder={t("feedBackModalProductQuestion")}
            suffixIcon={
              <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6.29289 6.29289C6.68342 6.68342 7.31658 6.68342 7.70711 6.29289L13 1" stroke="#9F9FA1" strokeWidth="1.5" />
              </svg>
            }
          >
            {problemTypeList.map(item => (
              <Option value={item.value} key={item.value}>
                {item.value}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="content"
          label={t("feedBackModalProductContQuestion")}
          rules={[
            {
              required: true,
              validator: Validator.emptyValidator,
            },
          ]}
        >
          <Input.TextArea placeholder={t("feedBackModalProductContQuestion")} />
        </Form.Item>
        <Form.Item
          name="email"
          label={t("common:email")}
          rules={[
            {
              required: true,
              validator: Validator.emptyValidator,
            },
          ]}
        >
          <Input placeholder={t("common:email")} readOnly />
        </Form.Item>
        <Form.Item name="image" label={t("feedBackModalAddImageBtn")}>
          {uploadFileObj ? (
            <div className="upload-file">
              {utils.omissionString(uploadFileObj.name, 5, 7)}
              <span className="close ms-2" onClick={handleDeleteFile}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4L12 12" stroke="#8372FF" />
                  <path d="M12 4L4 12" stroke="#8372FF" />
                </svg>
              </span>
            </div>
          ) : (
            <Upload {...uploadProps}>
              <Button
                className="upload-btn d-flex align-items-center justify-content-center"
                type="primary"
                ghost
                icon={
                  <svg className="me-1" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.5 2L8.5 14" stroke="currentColor" strokeWidth="1.5" />
                    <path d="M14.5 8H2.5" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                }
                loading={uploading}
              >
                {t("feedBackModalAddImageBtn")}
              </Button>
            </Upload>
          )}
        </Form.Item>
        <p className="small text-muted mb-4">
          <span className="d-block">{t("feedBackModalTips")}</span>
          <span>{t("feedBackModalTipsCont")}</span>
        </p>
        <Form.Item className="mb-0">
          <Button
            className="submit-btn py-2 fw-bolder d-flex align-items-center justify-content-center"
            type="primary"
            size="large"
            htmlType="submit"
            loading={submitting}
          >
            {t("common:submit")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default FeedbackModalRender;
